module.exports = __webpack_public_path__ + "img/crew2_7-8-2021.09a0b963.jpg";